import {createReducer} from '@reduxjs/toolkit';
import {setColorEnhanceMode, setEnhanceFilters} from '@src/actions/enhanceMode';
import {setMode as setUIMode} from '@src/actions/ui.ts';
import {UI_MODES} from '@src/constants';
import {ENHANCEMENT_MODE, IMG_FILTERS} from '@src/constants/enhancements';

export const initialState = {
  mode: ENHANCEMENT_MODE.OFF,
  // slider values,
  filters: {
    [IMG_FILTERS.BRIGHTNESS]: 0,
    [IMG_FILTERS.CONTRAST]: 0,
    [IMG_FILTERS.SATURATION]: 0,
  },
};

const tiles = createReducer(initialState, builder => {
  builder.addCase(setColorEnhanceMode, (state, {payload: mode}) => {
    state.mode = mode;
    state.filters = initialState.filters;
  });

  builder.addCase(setEnhanceFilters, (state, {payload}) => {
    state.filters[payload.filterName] = payload.value;
  });

  builder.addCase(setUIMode, (state, {payload}) => {
    if (payload === UI_MODES.COMPARE) {
      return initialState;
    }
  });
});

export default tiles;
